var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from "axios";
const viewerId = process.env.REACT_APP_VIEWER_ID;
const baseUrl = process.env.REACT_APP_HELLOAR_API;
const url = `${baseUrl}viewers/${viewerId}`;
export const getDetails = () => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c;
    const tags = localStorage.getItem("userTags");
    const tagsValue = tags && tags !== "undefined" ? JSON.parse(tags) : undefined;
    const requiredTag = tagsValue
        ? tagsValue.filter((tag) => tag.includes("group"))
        : undefined;
    const userLocationTag = requiredTag ? `${(_a = requiredTag[0]) === null || _a === void 0 ? void 0 : _a.replace(":", "_")}_data` : null;
    const res = yield axios.get(url);
    const details = (_c = (_b = res.data.configurations.filter((item) => item.key === userLocationTag)[0]) === null || _b === void 0 ? void 0 : _b.value) !== null && _c !== void 0 ? _c : {
        address: "",
        bank_details: "",
        gst_number: ""
    };
    return details;
});
export const getAllBankDetails = () => __awaiter(void 0, void 0, void 0, function* () {
    const res = yield axios.get(url);
    const bankDetailsArray = res.data.configurations.filter((item) => { var _a; return (_a = item.key) === null || _a === void 0 ? void 0 : _a.includes("group_"); });
    return bankDetailsArray;
});
export const patchDetails = (data, tag) => __awaiter(void 0, void 0, void 0, function* () {
    const userString = localStorage.getItem("user");
    const user = userString ? JSON.parse(userString) : undefined;
    let changedConfigData;
    let unchangedConfigData;
    const res = yield axios.get(url);
    if (!tag) {
        const tags = localStorage.getItem("userTags");
        const tagsValue = tags ? JSON.parse(tags) : undefined;
        const requiredTag = tagsValue
            ? tagsValue.filter((tag) => tag.includes("group"))
            : undefined;
        const userLocationTag = `${requiredTag[0].replace(":", "_")}_data`;
        unchangedConfigData = res.data.configurations.filter((item) => item.key !== userLocationTag);
        changedConfigData = [{ key: userLocationTag, value: data }];
    }
    else {
        unchangedConfigData = res.data.configurations.filter((item) => item.key !== tag);
        changedConfigData = [{ key: tag, value: data }];
    }
    const patchData = {
        configurations: [...unchangedConfigData, ...changedConfigData],
    };
    yield axios.patch(url, patchData, {
        headers: {
            "Content-Type": "application/json;charset=utf-8",
            Authorization: `Token ${user.access_token}`,
        },
    });
});
